export default __webpack_public_path__ + "static/media/spinner.f8e163e5.svg";